import {
  blank,
  indianSocket,
  interNationalSocket,
  Knob,
  m2,
  m2Possiblity,
  m4,
  m4Possiblity,
  m6,
  m6Possiblity,
  module_pro_switchs,
  module_touch_switchs,
  rj11,
  rj45,
  tvsocket,
  universalSocket,
  usb,
} from "./mapping";
import { v7 as uuidv7 } from "uuid";
import dayjs from "dayjs";
export const DateFormatter = (dateString) => {
  const formattedDate = dayjs(dateString).format("DD/MM/YYYY hh:mm A");
  return formattedDate;
};

export function generateUniqueId() {
  return "id-" + Date.now() + "-" + Math.floor(Math.random() * 1000);
}

export const formateContentList = (content, design) => {
  if (!design) {
    return content;
  }

  if (design?.frame == "acrylic") {
    return content;
  }

  const indianSockts = content?.filter((item) => item?.type == "indian_socket");

  const withoutIndianSocket = content?.filter(
    (item) => item?.type != "indian_socket"
  );
  return [...withoutIndianSocket, ...indianSockts];
};

export const getTotalDimansion = (content, isDownloadMode, size, item) => {
  let totalWidth = isDownloadMode
    ? item?.data?.width
    : getAccuratePixels(item?.data?.width);

  let totalHeight = 150;

  content?.forEach((item) => {
    let width = isDownloadMode ? item?.width : getAccuratePixels(item?.width);

    let marginRight = isDownloadMode
      ? item?.marginRight
      : getAccuratePixels(item?.marginRight);

    // let width = item?.width;
    let height = item?.height;

    totalWidth = totalWidth + width;
    totalHeight = totalHeight + height;
  });

  return {
    totalWidth,
    totalHeight,
  };
};

const singleElementFind = (data, index) => {
  let singleItems = ["rj45", "rj11", "usb", "tv_socket", "blank"];
  let trackingIndex = index - 1;

  if (index == 0) {
    return "yes";
  }

  let count = 0;
  for (let i = 0; i < index; i++) {
    const element = data[i];

    if (singleItems.includes(element.type)) {
      count = count + 1;
    }
  }

  let result = count / 2;

  if (count % 2 == 0) {
    return "yes";
  } else {
    return "no";
  }
};

export const calcMargin = (listItem, item, index, size, isDownloadMode) => {
  let singleItems = ["rj45", "rj11", "usb", "tv_socket", "blank"];

  let prevItem = listItem[index - 1];

  if (listItem?.length == index + 1) {
    return 0;
  }

  let absoluteMarginRight = 0;
  if (
    index == 1 &&
    listItem?.length > 1 &&
    listItem[index - 1]?.space == 0.5 &&
    (listItem[index]?.space == 2 || listItem[index]?.space == 3)
  ) {
    absoluteMarginRight = isDownloadMode ? 120 / 2 : getAccuratePixels(120 / 2);

    return absoluteMarginRight;
  }

  if (
    index == 0 &&
    listItem?.length > 1 &&
    listItem[index]?.space == 0.5 &&
    (listItem[index + 1]?.space == 2 || listItem[index + 1]?.space == 3)
  ) {
    console.log("Hellow orld");

    absoluteMarginRight = isDownloadMode ? 120 / 2 : getAccuratePixels(120 / 2);

    return absoluteMarginRight;
  }

  if (singleElementFind(listItem, index) == "no") {
    let marginRightdefault = isDownloadMode ? 120 : getAccuratePixels(120);
    console.log(listItem[index - 1]?.space);

    return marginRightdefault;
  }

  if (singleElementFind(listItem, index) == "yes") {
    console.log("Yes", index);
    let finalMarginRigth = item?.marginRight;
    if (item?.marginRight == 120) {
      if (size == 6 || size == 9) {
        finalMarginRigth = finalMarginRigth + 1;
      }
    }

    let marginRight = isDownloadMode
      ? finalMarginRigth
      : getAccuratePixels(finalMarginRigth);

    return marginRight;
  }

  return isDownloadMode
    ? item?.marginRight
    : getAccuratePixels(item.marginRight);
};

export const ROTUES = {
  login: "/auth/login",
  register: "/auth/register",
  adminLogin: "/auth/admin-login",
  home: "/",
  dashboard: "/dashboard",
  editTouch: "/edit-touch",
  downloadPdf: "/download-pdf",
};

export const VARIENTS = {
  "1_glass": m2Possiblity,
  "2_glass": [
    ...m2Possiblity,
    ...m4Possiblity,
    {
      id: uuidv7(),
      label: "Blank",
      value: "blank",
      data: blank,
    },
    {
      id: 4,
      label: "6A BIS socket",
      value: "indian_socket",
      data: indianSocket,
    },
  ],
  "3_glass": [
    ...m2Possiblity,
    ...m4Possiblity,
    ...m6Possiblity,
    {
      id: uuidv7(),
      label: "Blank",
      value: "blank",
      data: blank,
    },
    {
      id: 4,
      label: "6A BIS socket",
      value: "indian_socket",
      data: indianSocket,
    },
  ],
  "4_glass": [
    ...m2Possiblity,
    ...m4Possiblity,
    ...m6Possiblity,
    {
      id: uuidv7(),
      label: "Blank",
      value: "blank",
      data: blank,
    },
    {
      id: 4,
      label: "6A BIS socket",
      value: "indian_socket",
      data: indianSocket,
    },
  ],
  "6_glass": [
    ...m2Possiblity,
    ...m4Possiblity,
    ...m6Possiblity,
    {
      id: uuidv7(),
      label: "Blank",
      value: "blank",
      data: blank,
    },
    {
      id: 4,
      label: "6A BIS socket",
      value: "indian_socket",
      data: indianSocket,
    },
  ],
  "9_glass": [
    ...m2Possiblity,
    ...m4Possiblity,
    ...m6Possiblity,
    {
      id: uuidv7(),
      label: "Blank",
      value: "blank",
      data: blank,
    },
    {
      id: 4,
      label: "6A BIS socket",
      value: "indian_socket",
      data: indianSocket,
    },
  ],

  // archalic

  "1_acrylic": [
    ...m2Possiblity,
    {
      id: uuidv7(),
      label: "6A BIS socket",
      value: "indian_socket",
      data: indianSocket,
    },
    {
      id: uuidv7(),
      label: "16A Universal Socket",
      value: "universal_socket",
      data: universalSocket,
    },
    {
      id: uuidv7(),
      label: "International Socket",
      value: "international_socket",
      data: interNationalSocket,
    },
    {
      id: uuidv7(),
      label: "Knob",
      value: "Knob",
      data: Knob,
    },
    {
      id: uuidv7(),
      label: "RJ 11",
      value: "rj_11",
      data: rj11,
    },
    {
      id: uuidv7(),
      label: "RJ 45",
      value: "rj_45",
      data: rj45,
    },
    {
      id: uuidv7(),
      label: "USB",
      value: "usb",
      data: usb,
    },
    {
      id: uuidv7(),
      label: "Tv Socket",
      value: "tvsocket",
      data: tvsocket,
    },
    {
      id: uuidv7(),
      label: "Blank",
      value: "blank",
      data: blank,
    },
  ],
  "2_acrylic": [
    ...m2Possiblity,
    ...m4Possiblity,
    {
      id: 4,
      label: "6A BIS socket",
      value: "indian_socket",
      data: indianSocket,
    },
    {
      id: "uuid",
      label: "16A Universal Socket",
      value: "universal_socket",
      data: universalSocket,
    },
    {
      id: uuidv7(),
      label: "International Socket",
      value: "international_socket",
      data: interNationalSocket,
    },
    {
      id: uuidv7(),
      label: "Knob",
      value: "Knob",
      data: Knob,
    },
    {
      id: uuidv7(),
      label: "RJ 11",
      value: "rj_11",
      data: rj11,
    },
    {
      id: uuidv7(),
      label: "RJ 45",
      value: "rj_45",
      data: rj45,
    },
    {
      id: uuidv7(),
      label: "USB",
      value: "usb",
      data: usb,
    },
    {
      id: uuidv7(),
      label: "Tv Socket",
      value: "tvsocket",
      data: tvsocket,
    },
    {
      id: uuidv7(),
      label: "Blank",
      value: "blank",
      data: blank,
    },
  ],
  "3_acrylic": [
    ...m2Possiblity,
    ...m4Possiblity,
    ...m6Possiblity,
    {
      id: 4,
      label: "6A BIS socket",
      value: "indian_socket",
      data: indianSocket,
    },
    {
      id: "uuid",
      label: "16A Universal Socket",
      value: "universal_socket",
      data: universalSocket,
    },
    {
      id: uuidv7(),
      label: "International Socket",
      value: "international_socket",
      data: interNationalSocket,
    },
    {
      id: uuidv7(),
      label: "Knob",
      value: "Knob",
      data: Knob,
    },
    {
      id: uuidv7(),
      label: "RJ 11",
      value: "rj_11",
      data: rj11,
    },
    {
      id: uuidv7(),
      label: "RJ 45",
      value: "rj_45",
      data: rj45,
    },
    {
      id: uuidv7(),
      label: "USB",
      value: "usb",
      data: usb,
    },
    {
      id: uuidv7(),
      label: "Tv Socket",
      value: "tvsocket",
      data: tvsocket,
    },
    {
      id: uuidv7(),
      label: "Blank",
      value: "blank",
      data: blank,
    },
  ],
  "4_acrylic": [
    ...m2Possiblity,
    ...m4Possiblity,
    ...m6Possiblity,
    {
      id: 4,
      label: "6A BIS socket",
      value: "indian_socket",
      data: indianSocket,
    },
    {
      id: "uuid",
      label: "16A Universal Socket",
      value: "universal_socket",
      data: universalSocket,
    },
    {
      id: uuidv7(),
      label: "International Socket",
      value: "international_socket",
      data: interNationalSocket,
    },
    {
      id: uuidv7(),
      label: "Knob",
      value: "Knob",
      data: Knob,
    },
    {
      id: uuidv7(),
      label: "RJ 11",
      value: "rj_11",
      data: rj11,
    },
    {
      id: uuidv7(),
      label: "RJ 45",
      value: "rj_45",
      data: rj45,
    },
    {
      id: uuidv7(),
      label: "USB",
      value: "usb",
      data: usb,
    },
    {
      id: uuidv7(),
      label: "Tv Socket",
      value: "tvsocket",
      data: tvsocket,
    },
    {
      id: uuidv7(),
      label: "Blank",
      value: "blank",
      data: blank,
    },
  ],
  "6_acrylic": [
    ...m2Possiblity,
    ...m4Possiblity,
    ...m6Possiblity,
    {
      id: 4,
      label: "6A BIS socket",
      value: "indian_socket",
      data: indianSocket,
    },
    {
      id: "uuid",
      label: "16A Universal Socket",
      value: "universal_socket",
      data: universalSocket,
    },
    {
      id: uuidv7(),
      label: "International Socket",
      value: "international_socket",
      data: interNationalSocket,
    },
    {
      id: uuidv7(),
      label: "Knob",
      value: "Knob",
      data: Knob,
    },
    {
      id: uuidv7(),
      label: "RJ 11",
      value: "rj_11",
      data: rj11,
    },
    {
      id: uuidv7(),
      label: "RJ 45",
      value: "rj_45",
      data: rj45,
    },
    {
      id: uuidv7(),
      label: "USB",
      value: "usb",
      data: usb,
    },
    {
      id: uuidv7(),
      label: "Tv Socket",
      value: "tvsocket",
      data: tvsocket,
    },
    {
      id: uuidv7(),
      label: "Blank",
      value: "blank",
      data: blank,
    },
  ],
  "9_acrylic": [
    ...m2Possiblity,
    ...m4Possiblity,
    ...m6Possiblity,
    {
      id: uuidv7(),
      label: "6A BIS socket",
      value: "indian_socket",
      data: indianSocket,
    },
    {
      id: "uuid",
      label: "16A Universal Socket",
      value: "universal_socket",
      data: universalSocket,
    },
    {
      id: uuidv7(),
      label: "International Socket",
      value: "international_socket",
      data: interNationalSocket,
    },
    ,
    {
      id: uuidv7(),
      label: "Knob",
      value: "Knob",
      data: Knob,
    },
    {
      id: uuidv7(),
      label: "RJ 11",
      value: "rj_11",
      data: rj11,
    },
    {
      id: uuidv7(),
      label: "RJ 45",
      value: "rj_45",
      data: rj45,
    },
    {
      id: uuidv7(),
      label: "USB",
      value: "usb",
      data: usb,
    },
    {
      id: uuidv7(),
      label: "Tv Socket",
      value: "tvsocket",
      data: tvsocket,
    },
    {
      id: uuidv7(),
      label: "Blank",
      value: "blank",
      data: blank,
    },
  ],

  "1_module_touch_switch": [...module_touch_switchs],
  "10_touch_panel_pro": [{
    id: uuidv7(),
    label: "6A BIS socket",
    value: "indian_socket",
    data: indianSocket,
  },
  {
    id: "uuid",
    label: "16A Universal Socket",
    value: "universal_socket",
    data: universalSocket,
  },
  {
    id: uuidv7(),
    label: "International Socket",
    value: "international_socket",
    data: interNationalSocket,
  },
  ,
  {
    id: uuidv7(),
    label: "Knob",
    value: "Knob",
    data: Knob,
  },
  {
    id: uuidv7(),
    label: "RJ 11",
    value: "rj_11",
    data: rj11,
  },
  {
    id: uuidv7(),
    label: "RJ 45",
    value: "rj_45",
    data: rj45,
  },
  {
    id: uuidv7(),
    label: "USB",
    value: "usb",
    data: usb,
  },
  {
    id: uuidv7(),
    label: "Tv Socket",
    value: "tvsocket",
    data: tvsocket,
  },
  {
    id: uuidv7(),
    label: "Blank",
    value: "blank",
    data: blank,
  }, ...module_pro_switchs],

  "1_laminate_varient": [
    ...m2Possiblity,
    {
      id: uuidv7(),
      label: "6A BIS socket",
      value: "indian_socket",
      data: indianSocket,
    },
    {
      id: uuidv7(),
      label: "16A Universal Socket",
      value: "universal_socket",
      data: universalSocket,
    },
    {
      id: uuidv7(),
      label: "International Socket",
      value: "international_socket",
      data: interNationalSocket,
    },
    {
      id: uuidv7(),
      label: "Knob",
      value: "Knob",
      data: Knob,
    },
    {
      id: uuidv7(),
      label: "RJ 11",
      value: "rj_11",
      data: rj11,
    },
    {
      id: uuidv7(),
      label: "RJ 45",
      value: "rj_45",
      data: rj45,
    },
    {
      id: uuidv7(),
      label: "USB",
      value: "usb",
      data: usb,
    },
    {
      id: uuidv7(),
      label: "Tv Socket",
      value: "tvsocket",
      data: tvsocket,
    },
    {
      id: uuidv7(),
      label: "Blank",
      value: "blank",
      data: blank,
    },
  ],
  "2_laminate_varient": [
    ...m2Possiblity,
    ...m4Possiblity,
    {
      id: 4,
      label: "6A BIS socket",
      value: "indian_socket",
      data: indianSocket,
    },
    {
      id: "uuid",
      label: "16A Universal Socket",
      value: "universal_socket",
      data: universalSocket,
    },
    {
      id: uuidv7(),
      label: "International Socket",
      value: "international_socket",
      data: interNationalSocket,
    },
    {
      id: uuidv7(),
      label: "Knob",
      value: "Knob",
      data: Knob,
    },
    {
      id: uuidv7(),
      label: "RJ 11",
      value: "rj_11",
      data: rj11,
    },
    {
      id: uuidv7(),
      label: "RJ 45",
      value: "rj_45",
      data: rj45,
    },
    {
      id: uuidv7(),
      label: "USB",
      value: "usb",
      data: usb,
    },
    {
      id: uuidv7(),
      label: "Tv Socket",
      value: "tvsocket",
      data: tvsocket,
    },
    {
      id: uuidv7(),
      label: "Blank",
      value: "blank",
      data: blank,
    },
  ],
  "3_laminate_varient": [
    ...m2Possiblity,
    ...m4Possiblity,
    ...m6Possiblity,
    {
      id: 4,
      label: "6A BIS socket",
      value: "indian_socket",
      data: indianSocket,
    },
    {
      id: "uuid",
      label: "16A Universal Socket",
      value: "universal_socket",
      data: universalSocket,
    },
    {
      id: uuidv7(),
      label: "International Socket",
      value: "international_socket",
      data: interNationalSocket,
    },
    {
      id: uuidv7(),
      label: "Knob",
      value: "Knob",
      data: Knob,
    },
    {
      id: uuidv7(),
      label: "RJ 11",
      value: "rj_11",
      data: rj11,
    },
    {
      id: uuidv7(),
      label: "RJ 45",
      value: "rj_45",
      data: rj45,
    },
    {
      id: uuidv7(),
      label: "USB",
      value: "usb",
      data: usb,
    },
    {
      id: uuidv7(),
      label: "Tv Socket",
      value: "tvsocket",
      data: tvsocket,
    },
    {
      id: uuidv7(),
      label: "Blank",
      value: "blank",
      data: blank,
    },
  ],
  "4_laminate_varient": [
    ...m2Possiblity,
    ...m4Possiblity,
    ...m6Possiblity,
    {
      id: 4,
      label: "6A BIS socket",
      value: "indian_socket",
      data: indianSocket,
    },
    {
      id: "uuid",
      label: "16A Universal Socket",
      value: "universal_socket",
      data: universalSocket,
    },
    {
      id: uuidv7(),
      label: "International Socket",
      value: "international_socket",
      data: interNationalSocket,
    },
    {
      id: uuidv7(),
      label: "Knob",
      value: "Knob",
      data: Knob,
    },
    {
      id: uuidv7(),
      label: "RJ 11",
      value: "rj_11",
      data: rj11,
    },
    {
      id: uuidv7(),
      label: "RJ 45",
      value: "rj_45",
      data: rj45,
    },
    {
      id: uuidv7(),
      label: "USB",
      value: "usb",
      data: usb,
    },
    {
      id: uuidv7(),
      label: "Tv Socket",
      value: "tvsocket",
      data: tvsocket,
    },
    {
      id: uuidv7(),
      label: "Blank",
      value: "blank",
      data: blank,
    },
  ],
  "6_laminate_varient": [
    ...m2Possiblity,
    ...m4Possiblity,
    ...m6Possiblity,
    {
      id: 4,
      label: "6A BIS socket",
      value: "indian_socket",
      data: indianSocket,
    },
    {
      id: "uuid",
      label: "16A Universal Socket",
      value: "universal_socket",
      data: universalSocket,
    },
    {
      id: uuidv7(),
      label: "International Socket",
      value: "international_socket",
      data: interNationalSocket,
    },
    {
      id: uuidv7(),
      label: "Knob",
      value: "Knob",
      data: Knob,
    },
    {
      id: uuidv7(),
      label: "RJ 11",
      value: "rj_11",
      data: rj11,
    },
    {
      id: uuidv7(),
      label: "RJ 45",
      value: "rj_45",
      data: rj45,
    },
    {
      id: uuidv7(),
      label: "USB",
      value: "usb",
      data: usb,
    },
    {
      id: uuidv7(),
      label: "Tv Socket",
      value: "tvsocket",
      data: tvsocket,
    },
    {
      id: uuidv7(),
      label: "Blank",
      value: "blank",
      data: blank,
    },
  ],
  "9_laminate_varient": [
    ...m2Possiblity,
    ...m4Possiblity,
    ...m6Possiblity,
    {
      id: uuidv7(),
      label: "6A BIS socket",
      value: "indian_socket",
      data: indianSocket,
    },
    {
      id: "uuid",
      label: "16A Universal Socket",
      value: "universal_socket",
      data: universalSocket,
    },
    {
      id: uuidv7(),
      label: "International Socket",
      value: "international_socket",
      data: interNationalSocket,
    },
    ,
    {
      id: uuidv7(),
      label: "Knob",
      value: "Knob",
      data: Knob,
    },
    {
      id: uuidv7(),
      label: "RJ 11",
      value: "rj_11",
      data: rj11,
    },
    {
      id: uuidv7(),
      label: "RJ 45",
      value: "rj_45",
      data: rj45,
    },
    {
      id: uuidv7(),
      label: "USB",
      value: "usb",
      data: usb,
    },
    {
      id: uuidv7(),
      label: "Tv Socket",
      value: "tvsocket",
      data: tvsocket,
    },
    {
      id: uuidv7(),
      label: "Blank",
      value: "blank",
      data: blank,
    },
  ],
};

export const MODULE = {
  1: {
    width: 1100,
    height: 1075,
    paddingTop: 239,
    paddingBottom: 239,
    paddingLeft: 267,
    paddingRight: 267,
    marginRight: 120,
  },
  2: {
    width: 1796,
    height: 1075,
    paddingTop: 239,
    paddingBottom: 239,
    paddingLeft: 271,
    paddingRight: 271,
    marginRight: 120,
  },
  3: {
    width: 2617,
    height: 1075,
    paddingTop: 239,
    paddingBottom: 239,
    paddingLeft: 338,
    paddingRight: 338,
    marginRight: 120,
  },
  4: {
    width: 3089,
    height: 1075,
    paddingTop: 239,
    paddingBottom: 239,
    paddingLeft: 230,
    paddingRight: 230,
    marginRight: 120,
  },
  6: {
    width: 2617,
    height: 1821,
    paddingTop: 239,
    paddingBottom: 239,
    paddingLeft: 338,
    paddingRight: 338,
    marginRight: 121,
  },
  9: {
    width: 2617,
    height: 2622,
    paddingTop: 263,
    paddingBottom: 263,
    paddingLeft: 337,
    paddingRight: 337,
    marginRight: 121,
  },
  10: {
    width: 3381,
    height: 1515,
    paddingTop: 239,
    paddingBottom: 239,
    paddingLeft: 230,
    paddingRight: 230,
    marginRight: 121,
  },
};

export const LOGO_POSITION = {
  1: {
    bottom: 64,
    right: 64,
  },
  2: {
    bottom: 64,
    right: 64,
  },
  3: {
    bottom: 64,
    right: 64,
  },
  4: {
    bottom: 64,
    right: 64,
  },
  6: {
    bottom: 64,
    right: 64,
  },
  9: {
    bottom: 64,
    right: 64,
  },
  10: {
    bottom: 64,
    right: 64,
  },
};

export const getAccuratePixels = (pixel) => {
  return pixel / 4;
};

export const getLogoPositionMatrix = (size, frame) => {
  const matrix = LOGO_POSITION[size];

  if (frame == "module_touch_switch") {
    return {
      bottom: 25,
      right: 25,
    };
  }

  return matrix;
};

export const getBase64FromUrl = async (url) => {
  if (!url) {
    return null;
  }

  const res = await fetch(url);
  const blob = await res.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};
